import styled from 'styled-components';

const ChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  //height: calc(var(--vh, 1vh) * 100 - 50px); /* Fallback to 1vh if --vh is not defined for some reason */
  overflow: hidden;
  height: 100%;
`;

export default ChatContainer;
